// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gIPt","controls":"styles_controls__2TKYy","charLimit":"styles_charLimit__2F2_z","input":"styles_input__ILku4","send":"styles_send__1Vb_3"};